<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h6 class="bold text-secondary-light m-0">
        Professional Information
      </h6>
      <i
        v-if="isEditable"
        class="fa-solid fa-pen-to-square text-primary"
        @click="editProfessionalInfo"
      ></i>
    </div>

    <div class="br-8 table-scroll-wrapper">
      <table
        class="table table-inner-bordered m-0 align-middle text-start bg-blue-light-2 br-8"
      >
        <tbody>
          <tr v-for="(row, rowIndex) in groupedFields" :key="rowIndex">
            <td v-for="(field, colIndex) in row" :key="colIndex">
              <span class="text-primary d-block">{{ field.label }}</span>
              <span :class="field.value ? 'text-secondary bold' : 'text-muted'">
                {{ field.value || "N/A" }}
              </span>
            </td>
            <!-- Fill remaining empty <td>s if fewer than 4 in this row -->
            <!-- <td v-for="n in 4 - row.length" :key="'empty-' + n"></td> -->
          </tr>
        </tbody>
      </table>
    </div>

    <ProfessionalInfoEdit
      :candidateInfo="profile"
      :isShowPopup="EditModal.isShowPopup"
      @modalCallBack="ProfessionalInfoModalCallBack"
      v-if="EditModal.isShowPopup"
    />
    <Modal
      v-if="splConfirmModal.isShowPopup"
      :modalTitle="splConfirmModal.modalTitle"
      :modalColor="splConfirmModal.modalColor"
      :modalContent="splConfirmModal.modalContent"
      :isShowPopup="splConfirmModal.isShowPopup"
      :buttons="splConfirmModal.buttons"
      :modalCallBack="splModalCallBack"
      :closeOnBackdrop="false"
    />
  </div>
</template>
<script>
import { Role, getScope } from "@/helpers/helper";
import ProfessionalInfoEdit from "./EditForm/ProfessionalInfoEdit";
import { mapActions, mapGetters } from "vuex";
import Modal from "@/components/reusable/Modal";
import isJobSupplier from "@/mixins/isJobSupplier";
import m from "moment";

export default {
  mixins: [isJobSupplier],
  props: {
    profile: {
      type: Object,
      default: null,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    isModalView: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ProfessionalInfoEdit,
    Modal,
  },
  data() {
    return {
      currentUserRole: getScope(),
      Role,
      EditModal: {
        isShowPopup: false,
      },
      splConfirmModal: {
        modalColor: "primary",
        modalTitle: "NOTIFICATION",
        modalContent: "Do you need to reset the Special Interest?",
        isShowPopup: false,
        buttons: ["No", "Yes"],
      },
      showMore: false,
    };
  },
  computed: {
    ...mapGetters([
      "getLicense",
      "currentUserType",
      "isCandidateRoleFromAccessToken",
      "isEducationalInstituteOrg",
    ]),
    isStudent() {
      return this.profile?.is_student || false;
    },
    studentCourse() {
      return this.profile?.qualifications?.length
        ? this.profile?.qualifications[0]
        : "--";
    },
    study_location() {
      return this.studentCourse?.country_name || "--";
    },
    courseStartDate() {
      return this.studentCourse
        ? this.formatDate(this.studentCourse.course_start_date)
        : "--";
    },
    courseEndDate() {
      return this.studentCourse
        ? this.formatDate(this.studentCourse.predicted_completion_date)
        : "--";
    },

    getCandidateSpecialInterest() {
      return (
        (this.profile?.candidate_specialities &&
          this.profile?.candidate_specialities) ||
        []
      );
    },
    speciality() {
      return this.profile.speciality?.speciality || "--";
    },
    subSpeciality() {
      if (this.isDentist) return "N/A";
      return this.profile.sub_speciality?.sub_speciality || "--";
    },
    pqrlevel() {
      const pqr =
        this.profile.pqr_levels.filter(({ potential }) => !potential) || [];
      if (pqr.length) {
        if (pqr[0]?.working_candidate_level && !this.isAHP) {
          const level = pqr[0]?.working_candidate_level;
          const country_code =
            pqr[0]?.pqr_detail?.pqr_header?.country?.country_code;
          return country_code ? `${level}(${country_code})` : level;
        }
      }
      return "--";
    },
    candidateLevel() {
      return this.profile?.candidate_level?.candidate_level || "--";
    },
    qualification_year() {
      let index = this.profile.qualifications.findIndex(
        (x) => x.qualification_name === this.profile.highest_qualification_name
      );
      return this.profile.qualifications[index]?.year_awarded || "--";
    },
    qualification_country() {
      let index = this.profile.qualifications.findIndex(
        (x) => x.qualification_name === this.profile.highest_qualification_name
      );
      return this.profile.qualifications[index]?.country_name || "--";
    },
    psvDataFlow() {
      if (this.profile.psv_dataflow_complete != null) {
        if (["Yes", true, "all"].includes(this.profile.psv_dataflow_complete)) {
          return "All";
        } else if (
          ["No", false, "none"].includes(this.profile.psv_dataflow_complete)
        ) {
          return "None";
        } else if (this.profile.psv_dataflow_complete === "some") {
          return "Some";
        }
      }
      return "N/A";
    },
    specialInterests() {
      return (
        _(this.getCandidateSpecialInterest)
          .filter(({ special_interest, other_special_interest }) => {
            return other_special_interest || special_interest;
          })
          .map(({ special_interest, other_special_interest }) => {
            return !other_special_interest
              ? special_interest?.special_interest
              : "Other - " + other_special_interest;
          })
          .value()
          .join(", ") || "--"
      );
    },
    highestQualification() {
      return (
        (this.profile?.qualifications &&
          this.profile.qualifications.length > 1 &&
          this.profile?.qualifications.filter(({ main }) => main)) ||
        (this.profile.qualifications.length === 1 &&
          this.profile?.qualifications) ||
        []
      );
    },
    qualificationName() {
      if (
        this.profile?.qualifications &&
        this.profile?.highest_qualification_name &&
        this.profile?.highest_qualification_name == "Other - not listed"
      ) {
        return _(this.profile?.qualifications)
          .filter((qualification) => {
            return (
              qualification?.main &&
              qualification?.qualification_name ==
                this.profile?.highest_qualification_name
            );
          })
          .map((qualification) => {
            return qualification?.other_qualification_name
              ? "Other - " + qualification?.other_qualification_name
              : null;
          })
          .value()
          .toString();
      } else {
        return (
          this.highestQualification.length &&
          this.highestQualification
            .map(
              ({
                qualification_name,
                description,
                qualification: { allow_subject_input },
              }) =>
                `${qualification_name}${
                  allow_subject_input && description
                    ? "(" + description + ")"
                    : ""
                }`
            )
            .join()
        );
      }
    },
    activeLicense() {
      let activeLicense = this.getLicense
        ? this.getLicense.some((ele) => ele.current_license == true)
        : false;
      return activeLicense ? "Yes" : "No";
    },
    isNurse() {
      return this.profile?.candidate_type_id
        ? this.profile?.candidate_type_id === 2
        : false;
    },
    isAHP() {
      return this.profile?.candidate_type_id
        ? this.profile?.candidate_type_id === 3
        : false;
    },
    isDentist() {
      return this.profile?.candidate_type_id
        ? this.profile?.candidate_type_id === 4
        : false;
    },
    isNonClinicalAdmin() {
      return this.profile?.candidate_type_id
        ? this.profile?.candidate_type_id === 6
        : false;
    },
    isStudent() {
      return this.profile.is_student || false;
    },
    studentQualification() {
      return this.profile?.qualifications?.[0] || {};
    },
    isSponsored() {
      return this.profile?.is_sponsored;
    },
    sponsoredDetails() {
      return this.profile?.sponsored;
    },
    studentCourse() {
      return this.profile?.student_course;
    },
    trainingCourse() {
      return this.profile?.student_course?.training_course;
    },
    groupedFields() {
      const chunkSize = 4;
      const chunks = [];
      for (let i = 0; i < this.profileFields.length; i += chunkSize) {
        chunks.push(this.profileFields.slice(i, i + chunkSize));
      }
      return chunks;
    },
    profileFields() {
      const data = [];

      if (!this.isStudent) {
        data.push(
          { label: "Speciality", value: this.speciality },

          !this.isDentist &&
            !this.isNonClinicalAdmin && {
              label: this.isNurse ? "Expertise" : "Sub Speciality",
              value: this.subSpeciality,
            },

          !this.isNonClinicalAdmin && {
            label: "Special Interest",
            value: this.specialInterests,
          },

          (this.isDentist || this.isNonClinicalAdmin) && {
            label: this.isNonClinicalAdmin
              ? "Highest Qualification"
              : "Highest Medical Qual",
            value: this.qualificationName || "--",
          },

          !this.isDentist &&
            !this.isNonClinicalAdmin && {
              label: this.isStudent ? "Course level" : "Highest Medical Qual",
              value: this.qualificationName || "--",
            },

          this.isNonClinicalAdmin && {
            label: "Country Obtained",
            value: this.qualification_country,
          },

          !this.isNonClinicalAdmin &&
            !this.isStudent && {
              label: "Country Obtained",
              value: this.qualification_country,
            },

          !this.isNonClinicalAdmin &&
            this.isStudent && {
              label: "Study Location",
              value: this.study_location,
            },

          this.isStudent && {
            label: "Course Start Date",
            value: this.courseStartDate,
          },

          this.isStudent && {
            label: "Course End Date",
            value: this.courseEndDate,
          },

          this.isStudent && {
            label: "Course Mode",
            value: this.studentCourse?.full_part_time || "--",
          },

          this.isStudent && {
            label: "Sponsored student",
            value: this.profile?.is_sponsored ? "Yes" : "No",
          },

          !this.isStudent && {
            label: "Year Obtained",
            value: this.qualification_year,
          },

          !this.isNonClinicalAdmin &&
            !this.isCandidateRoleFromAccessToken && {
              label: "Suitable For",
              value: this.pqrlevel,
            },

          this.isNonClinicalAdmin && {
            label: "Working As",
            value: this.candidateLevel || "--",
          },

          {
            label: "Current Job Title",
            value: this.profile?.current_job || "--",
          }
        );
      }

      if (this.isStudent && !this.studentCourse) {
        data.push(
          {
            label: "Study Location",
            value: this.studentQualification?.country_name || "--",
          },
          {
            label: "Course level",
            value: this.studentQualification?.qualification_name || "--",
          },
          {
            label: "Course Start Date",
            value:
              this.formatDate(this.studentQualification?.course_start_date) ||
              "--",
          },
          {
            label: "Course End Date",
            value:
              this.formatDate(
                this.studentQualification?.predicted_completion_date
              ) || "--",
          }
        );

        data.push(
          {
            label: "Is your course",
            value: this.studentQualification?.full_part_time || "--",
          },
          {
            label: "Course Mode",
            value:
              this.studentQualification?.distance_learning === true
                ? "Yes"
                : this.studentQualification?.distance_learning === false
                ? "No"
                : "Classroom based",
          },
          {
            label: "Sponsored student",
            value: this.isSponsored ? "Yes" : "No",
          },
          this.isSponsored && {
            label: "Sponsorship Duration",
            value:
              this.formatDate(this.sponsoredDetails?.start_date) +
              " - " +
              (this.sponsoredDetails?.end_date
                ? this.formatDate(this.sponsoredDetails.end_date)
                : "?"),
          }
        );
      }

      if (this.isStudent && this.studentCourse) {
        data.push(
          {
            label: "Course Title",
            value: this.trainingCourse?.course_title || "--",
          },
          {
            label: "Is your course",
            value: this.studentCourse?.full_part_time || "--",
          },
          {
            label: "Start Date",
            value: formatDate(this.studentCourse?.course_start_date) || "--",
          },
          {
            label: "Completion Date",
            value: formatMonthYear(this.studentCourse?.course_end_date) || "--",
          },
          {
            label: "Course Mode",
            value:
              this.studentCourse &&
              this.studentCourse.distance_learning === true
                ? "Yes"
                : this.studentCourse &&
                  this.studentCourse.distance_learning === false
                ? "No"
                : "Classroom based",
          },
          {
            label: "Sponsored student",
            value: this.isSponsored ? `Yes` : "No",
          },
          {
            label: "Sponsorship Start Date",
            value: formatDate(this.sponsoredDetails?.start_date) || "--",
          },
          {
            label: "Sponsorship Expiry Date",
            value: formatDate(this.sponsoredDetails?.end_date) || "--",
          }
        );
      }

      return data.filter(Boolean);
    },
  },
  methods: {
    ...mapActions([
      "updateCandidate",
      "fetchQualification",
      "deleteSplInterestWithoutToast",
      "fetchspecialInterest",
      "showToast",
      "fetchPQRLevels",
    ]),
    editProfessionalInfo() {
      this.EditModal.isShowPopup = true;
    },
    ProfessionalInfoModalCallBack(action, data, isSpecialityChanged) {
      this.EditModal.isShowPopup = false;
      if (action === true && data != null) {
        const { customer_uid } = this.profile;
        let appentAction = this.updateCandidate({ data, customer_uid });
        Promise.all([appentAction]).then((res) => {
          this.fetchPQRLevels();
          if (isSpecialityChanged?.length) {
            this.fetchQualification();
            if (
              this.getCandidateSpecialInterest?.length &&
              isSpecialityChanged.some((val) => val == "speciality_id")
            ) {
              this.splConfirmModal.isShowPopup = true;
            }
          }
        });
      }
    },
    splModalCallBack(action) {
      this.splConfirmModal.isShowPopup = false;
      if (action == "Yes") {
        let appendAction = [];
        this.getCandidateSpecialInterest.forEach((val) => {
          if (val.special_interest_id)
            appendAction = this.deleteSplInterestWithoutToast(
              val.candidate_speciality_id
            );
        });
        Promise.all([appendAction]).then((res) => {
          this.fetchspecialInterest();
          this.showToast({
            class: "bg-success text-white",
            message: "Special Interest reset successful",
          });
        });
        this.$parent.goToSplInterestSection();
      }
    },
    ShowMoreLess() {
      this.showMore = !this.showMore;
    },
    formatDate(date) {
      return date ? m(date).format("DD-MMM-YYYY") : date;
    },
    formatMonthYear(date) {
      return date ? m(date).format("YYYY-MMM") : date;
    },
  },
};
</script>
